import React, {useState} from "react"
import classNames from "classnames"
import Icon from "../Icon/Icon"
import {Insight} from "./AiInsightsView"

export interface AiInsightsProps {
	items: Insight[]
}

export function AiInsightsWithItems({items}: AiInsightsProps) {
	const [openIndices, setOpenIndices] = useState<number[]>([])

	const toggleInsight = (idx: number) => {
		setOpenIndices((prev) => (prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]))
	}

	return (
		<div className="ai-insights-items">
			{items.map((item, idx) => {
				const hasTitle = Boolean(item.title && item.title.trim())
				const isOpen = hasTitle ? openIndices.includes(idx) : true
				return (
					<div key={idx} className="ai-insights-item">
						{hasTitle && (
							<div className="ai-insights-item-header" onClick={() => toggleInsight(idx)}>
								<span className="ai-insights-item-title">{item.title}</span>
								<Icon
									icon="arrow-down-chevron"
									size={16}
									className={classNames("ai-insights-chevron", {
										open: isOpen,
									})}
								/>
							</div>
						)}
						<div
							className={classNames("ai-insights-item-content", {
								open: isOpen,
								"no-header": !hasTitle,
							})}
						>
							{item.description}
						</div>
					</div>
				)
			})}
		</div>
	)
}
